export default __webpack_public_path__ + "static/media/47.f7354a40.jpg";